"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomState = void 0;
const tslib_1 = require("tslib");
const ircv3_1 = require("ircv3");
/** @private */
let RoomState = class RoomState extends ircv3_1.Message {
};
tslib_1.__decorate([
    (0, ircv3_1.MessageParamDefinition)({
        type: 'channel'
    })
], RoomState.prototype, "channel", void 0);
RoomState = tslib_1.__decorate([
    (0, ircv3_1.MessageType)('ROOMSTATE')
], RoomState);
exports.RoomState = RoomState;
